<template>
  <div v-if="!loading">

    <div v-if="!hasFavoriteStaticSearches" class="panel panel-default panel-stretch">
      <div class="panel-heading">
        Werkvoorraad
      </div>
      <div class="panel-body no-padding">
        <div class="navbar-text">
          <p>Deze werkvoorraad is nu nog leeg.</p>
          <p>
            U kan items toevoegen door bij <a href="#selections">selecties</a> deze
            <a-tooltip>
              <template slot="title">
                Klik hiervoor (in selecties) op een ster.
              </template>
              als favoriet te markeren.
            </a-tooltip>
          </p>
        </div>
      </div>
    </div>

    <div v-else class="category-collapsable-favorite-static-selections-overview">
      <a-collapse :active-key="activeWorkCollapsePanels" @change="handleCollapse">
        <a-collapse-panel v-for="(category, key) in categories"
                          :key="key"
                          v-if="shouldRender(key)"
                          :header="category.name">
          <!--          <span v-if="lengthStaticSearchesByKey(key) > 0" slot="extra">{{ lengthStaticSearchesByKey(key) }}</span>-->
          <StaticSearchButton v-for="staticSearch in staticSearchesByKey(key)"
                              :staticSearch="staticSearch"
                              :userId="userId"
                              class="staticSearchItem"
                              :key="staticSearch.extended_key"
                              v-if="staticSearch.count > 0
                                                        || (
                                                        staticSearch.key !== 'e895baeec559d8d81466a3b2bdfbdd07'
                                                        && staticSearch.key !== '8afa8005716c85a6ed2f0746dd010670'
                                                        && staticSearch.key !== '3a1b793d94e84e5cd0f9a7ee1fbf788b'
                                                        && staticSearch.key !== '6afdd1e41cf7f78004fc075c02ce7974'
                                                        )"/>
        </a-collapse-panel>
      </a-collapse>
    </div>
  </div>

  <div v-else class="navbar-text">
    <p>Laden...</p>
  </div>
</template>

<script>
import store from '~/store';
import searchModule from '~/modules/static_search/store';
import staticSearchApi from '~/api/staticSearch';
// import {mapActions, mapGetters} from 'vuex'; // BE AWARE! Using mapActions will (currently) result in recursive errors! -WvdG
import {mapGetters, mapActions} from 'vuex';
import {Skeleton} from 'vue-loading-skeleton';
import StaticSearchButton from "~/modules/static_search/components/StaticSearchButton";
import ACol from "ant-design-vue/es/grid/Col";

export default {
  name: "FavoriteStaticSearches",
  props: {
    userId: {
      required: true,
      type: [Number, String]
    }
  },
  data() {
    return {
      categories: [],
      values: [],
      exportStatus: 0,
      percentageDone: 0,
      exportHash: null,
      mode: 'left',
      loading: true
    }
  },
  computed: {
    ...mapGetters('search', [
      'favoriteStaticSearches',
      'hasFavoriteStaticSearches',
      'findFavoriteStaticSearchesByKey',
      'activeWorkCollapsePanels'
    ]),
    // BE AWARE! Using the mapActions will result in recursive errors! -WvdG
    // TODO find the cause for the recursive error
    // ...mapActions('search', [
    //   'setFavoriteStaticSearches',
    // ]),
  },

  created() {
    if (!store.hasModule('search')) {
      store.registerModule('search', searchModule)
    }

    this.initialiseStore();
  },

  mounted() {
    staticSearchApi.onlyFavorites(this.userId)
        .then((data) => {
          this.$store.dispatch('search/setFavoriteStaticSearches', data.data);
          staticSearchApi.getCategories()
              .then((data) => {
                this.categories = data;
                this.loading = false;
              });
        });
  },

  methods: {
    ...mapActions('search', [
      'setActiveWorkCollapsePanels',
      'initialiseStore',
    ]),
    handleCollapse(value) {
      this.setActiveWorkCollapsePanels(value);
    },
    staticSearchesByKey(key) {
      let staticSearches = this.findFavoriteStaticSearchesByKey(key);
      if (typeof staticSearches === 'undefined') {
        return {};
      }
      return staticSearches;
    },
    lengthStaticSearchesByKey(key) {
      return this.staticSearchesByKey(key).length;
    },
    shouldRender(key) {
      return (this.lengthStaticSearchesByKey(key) > 0);
    }
  },

  components: {
    ACol,
    StaticSearchButton,
    Skeleton
  },
}
</script>

<style scoped>
table.table th, table.table td {
  padding: 1.5rem 1rem;
}

.staticSearchItem {
  float: left;
  width: 33.33%;
  padding: 1rem 2rem;
}

</style>